export const CONTENT_TYPES = {
    IMAGE: 'image',
    HTML: 'html',
    TEXT: 'text',
    JSON: 'json',
    LINK: 'link',
  };